import styled from "styled-components";
import {MarketingObjection} from "marketing/MarketingObjection";
import {brand, fontFamilies} from "../../theme/tokens";

/**
 * Externalized styles for {@link ./VerificationStep} (migrated on the ui#790 spacing rework, per the
 * styles-beside-component convention).
 */

export const Root = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	text-align: center;
	gap: 14px;
	/* Tightened from 26/18 (ui#790): the card read as mostly air around five short rows. */
	padding: 20px 6px 10px 6px;
	font-family: ${fontFamilies.sans};
	/* Long unbroken addresses in the "we emailed …" line must wrap, never widen the card. */
	overflow-wrap: anywhere;
`;

export const Title = styled.h2`
	margin: 0;
	font-size: 19px;
	font-weight: 700;
	color: ${({theme}) => theme.tokens.ink};
`;

export const Copy = styled.p`
	margin: 0;
	font-size: 13.5px;
	line-height: 1.55;
	color: ${({theme}) => theme.tokens.ink2};
	max-width: 300px;
`;

/* Monospaced, letter-spaced entry — six glyphs read as a code, not a word. */
export const CodeInput = styled.input`
	width: 100%;
	max-width: 236px;
	box-sizing: border-box;
	padding: 12px 8px 12px 16px;
	font-family: ${fontFamilies.mono};
	font-size: 21px;
	letter-spacing: 8px;
	text-align: center;
	text-transform: uppercase;
	color: ${({theme}) => theme.tokens.ink};
	background: ${({theme}) => theme.tokens.field};
	border: 1px solid ${({theme}) => theme.tokens.line};
	border-radius: 12px;
	outline: none;

	&:focus {
		border-color: ${({theme}) => theme.tokens.focusOutline};
	}
`;

/**
 * The marketing objection box (kitecorp/transferify-ui#3503) in this centred column: as wide as the step's
 * prose, its own text left-aligned like everywhere else it appears, and spaced by the column's gap
 * rather than by the margins it carries in the login modal's form.
 */
export const Objection = styled(MarketingObjection)`
	&& {
		box-sizing: border-box;
		width: 100%;
		max-width: 300px;
		margin: 0;
		text-align: left;
	}
`;

export const ErrorLine = styled.div`
	color: ${brand.error};
	font-size: 13px;
	max-width: 300px;
`;

/* 44px minimum touch target (mobile checklist). */
export const VerifyButton = styled.button`
	min-height: 44px;
	min-width: 150px;
	border: none;
	border-radius: 12px;
	background: ${({theme}) => theme.tokens.actionFill};
	color: ${({theme}) => theme.tokens.actionInk};
	font-family: ${fontFamilies.sans};
	font-size: 15px;
	font-weight: 700;
	cursor: pointer;

	&:disabled {
		opacity: 0.45;
		cursor: default;
	}
`;

/**
 * The 44px minimum touch target stays (mobile checklist) — but the HIT box no longer spends its
 * height on layout (ui#790): 13.5px text centered in 44px, stacked twice with the column's 14px gap,
 * put ~40px of visible air between two one-line links. The negative margins pull the boxes back so
 * the targets stay 44px tall and merely abut.
 */
export const QuietLink = styled.button`
	background: none;
	border: none;
	color: ${({theme}) => theme.tokens.ink2};
	text-decoration: underline;
	cursor: pointer;
	font-family: ${fontFamilies.sans};
	font-size: 13.5px;
	padding: 4px 8px;
	min-height: 44px;
	margin: -9px 0;

	&:disabled {
		opacity: 0.5;
		cursor: default;
	}
`;
